import produce from "immer";
import { getFormattedAmount } from "Shared/Utils";
import actionTypes from "../Actions/types";

let initialState = {
    assets: [],
    selectedAsset: {},
    currentPortfolioAssets: [],
    holdMyResult: {},
};

const roundQty = (val) => Number(Number(val || 0).toFixed(8));

let reducer = (state = initialState, action) =>
    produce(state, (draft) => {
        switch (action.type) {
            case actionTypes.UPDATE_BACKEDUP_ASSETS:
                draft.assets = action.payload;
                break;
            case actionTypes.ADD_ASSET:
                draft.assets = [...draft.assets, action.payload];
                break;
            case actionTypes.DELETE_PORTFOLIO: {
                const deletedUid = action.payload?.uid;
                if (deletedUid) {
                    draft.assets = draft.assets.filter(
                        (asset) => asset.portfolioId !== deletedUid
                    );
                    draft.currentPortfolioAssets =
                        draft.currentPortfolioAssets.filter(
                            (asset) => asset.portfolioId !== deletedUid
                        );
                }
                break;
            }
            case actionTypes.SET_PORTFOLIO_ASSETS:
                draft.currentPortfolioAssets = draft.assets.filter(
                    (asset) => asset.portfolioId === action.payload.uid
                );
                break;
            case actionTypes.SET_SELECTED_ASSET:
                draft.selectedAsset = action.payload;
                break;
            case actionTypes.HOLD_MY_RESULT:
                draft.holdMyResult = action.payload;
                break;
            case actionTypes.ADD_TRANSACTION:
                draft.assets = draft.assets.map((item) => {
                    if (item.uid === draft.selectedAsset.uid) {
                        let data = {
                            ...draft.selectedAsset,
                            transactions: draft.selectedAsset.transactions
                                ? [
                                      ...draft.selectedAsset.transactions,
                                      action.payload.transaction,
                                  ]
                                : [action.payload.transaction],
                            portfolio: action.payload.portfolio,
                        };
                        draft.selectedAsset = data;
                        return data;
                    } else {
                        return item;
                    }
                });
                break;

            case actionTypes.BUY: {
                action.payload.currentInvestment = Number(
                    getFormattedAmount(action.payload.currentInvestment, false)
                );
                action.payload.averagePPC = Number(
                    getFormattedAmount(action.payload.averagePPC, false)
                );
                action.payload.newInvestment = Number(
                    getFormattedAmount(action.payload.newInvestment, false)
                );

                let isFirstInvestment =
                    action.payload.averagePPC === 0 &&
                    action.payload.currentInvestment === 0;
                let numberOfCoins = !isFirstInvestment
                    ? roundQty(
                          action.payload.currentInvestment /
                              action.payload.averagePPC
                      )
                    : 0;
                let __numberOfCoins =
                    action.payload.numberOfTokens !== undefined
                        ? roundQty(action.payload.numberOfTokens)
                        : roundQty(
                              action.payload.newInvestment /
                                  action.payload.marketPrice
                          );
                let newTotalCoins = roundQty(numberOfCoins + __numberOfCoins);
                let newTotalInvestment = Number(
                    getFormattedAmount(
                        action.payload.currentInvestment +
                            action.payload.newInvestment,
                        false
                    )
                );
                let _portfolio = {
                    previous: {
                        investment: action.payload.currentInvestment,
                        numberOfCoins,
                        marketPrice: action.payload.averagePPC,
                    },
                    latest: {
                        investment: newTotalInvestment,
                        numberOfCoins: newTotalCoins,
                        marketPrice:
                            newTotalCoins > 0
                                ? Number(
                                      getFormattedAmount(
                                          newTotalInvestment / newTotalCoins,
                                          false
                                      )
                                  )
                                : 0,
                    },
                    transactionMarketPrice: action.payload.marketPrice,
                };
                draft.holdMyResult = _portfolio;
                break;
            }

            case actionTypes.SELL: {
                action.payload.currentInvestment = Number(
                    getFormattedAmount(action.payload.currentInvestment, false)
                );
                action.payload.averagePPC = Number(
                    getFormattedAmount(action.payload.averagePPC, false)
                );
                action.payload.marketPrice = Number(
                    getFormattedAmount(action.payload.marketPrice, false)
                );
                let _numberOfCoins = roundQty(
                    action.payload.currentInvestment /
                        action.payload.averagePPC
                );

                let amountToSell =
                    action.payload.coins2Sell * action.payload.marketPrice;
                amountToSell = Number(getFormattedAmount(amountToSell, false));
                let totalCoins = roundQty(
                    Math.max(0, _numberOfCoins - action.payload.coins2Sell)
                );
                const isExit = totalCoins <= 1e-8;
                if (isExit) {
                    totalCoins = 0;
                }
                let newInvestment = Number(
                    getFormattedAmount(
                        totalCoins * action.payload.averagePPC,
                        false
                    )
                );

                let portfolio = {
                    previous: {
                        investment: Number(
                            getFormattedAmount(
                                _numberOfCoins * action.payload.averagePPC,
                                false
                            )
                        ),
                        numberOfCoins: _numberOfCoins,
                        marketPrice: action.payload.averagePPC,
                    },
                    latest: {
                        investment: isExit ? 0 : newInvestment,
                        numberOfCoins: totalCoins,
                        marketPrice: isExit ? 0 : action.payload.averagePPC,
                        returns: Number(
                            getFormattedAmount(
                                totalCoins * action.payload.marketPrice,
                                false
                            )
                        ),
                        sellInfo: {
                            amountToSell,
                            intialCapitalForPurchase: Number(
                                getFormattedAmount(
                                    action.payload.averagePPC *
                                        action.payload.coins2Sell,
                                    false
                                )
                            ),
                        },
                    },
                    transactionMarketPrice: action.payload.marketPrice,
                };
                draft.holdMyResult = portfolio;
                break;
            }
            default:
                return draft;
        }
    });

export default reducer;
